import { createNamespacedHelpers } from 'vuex';
import PieChart from '@/components/common/PieChart/PieChart.vue';
import moment from 'moment';
import showToast from '@/util/toast';
import { showSwal } from '@/util/swal';
import i18n from '../../../locales/i18n';
import Constants from '../../../constants/Constants';

const authMapper = createNamespacedHelpers('global/auth');

export default {
	components: { PieChart },

	data() {
		return {
			countDownDateTime: [
				{
					number: '00',
					text: Constants.DATE_TEXT.DAY,
				},
				{
					number: '00',
					text: Constants.DATE_TEXT.HOUR,
				},
				{
					number: '00',
					text: Constants.DATE_TEXT.MINUTE,
				},
				{
					number: '00',
					text: Constants.DATE_TEXT.SECOND,
				},
			],
			USERNAME_RULES: 'usernameRequired',
			PASSWORD_RULES:
				'passwordSignupRequired|minPasswordLength:8|maxPasswordLength:16|atleastLowercase|atleastUppercase|atleastNumber|containsAtleastOneSpecialChar|notContainsSpace',
			schema: {
				oldPassword: '',
				newPassword: '',
				confirmNewPassword: '',
			},
			regions: ['JP', 'VN', 'US'],
			regionsDropdownOpen: false,
			isShowOldPassword: false,
			isShowNewPassword: false,
			isShowConfirmPassword: false,
		};
	},

	computed: {
		...authMapper.mapState(['username', 'userInfo', 'trialEndDate', 'detectedResults']),

		disableSaveButton() {
			return this.userInfo?.activeStatus === 'deactivated';
		},
		translateUsername() {
			return this.$t('user_name');
		},
		translateMail() {
			return this.$t('email');
		},
		translateOrganization() {
			return this.$t('organization');
		},
		translateRegion() {
			return this.$t('region');
		},
		translateRegion() {
			return this.$t('regionPlaceholder');
		},
		translateMail() {
			return this.$t('mailPlaceholder');
		},
		translateOrganization() {
			return this.$t('organizationPlaceholder');
		},
	},

	watch: {
		trialEndDate: {
			immediate: true,
			async handler(newValue) {
				if (newValue) {
					await this.countDown();
					await this.countDownTimer();
				}
			},
		},
	},

	filters: {
		filterDateText(dateText) {
			switch (dateText.toLowerCase()) {
				case Constants.DATE_TEXT.DAY:
					return i18n.t('days');
				case Constants.DATE_TEXT.HOUR:
					return i18n.t('hours');
				case Constants.DATE_TEXT.MINUTE:
					return i18n.t('minutes');
				case Constants.DATE_TEXT.SECOND:
					return i18n.t('seconds');

				default:
					break;
			}
		},
	},

	methods: {
		...authMapper.mapActions([
			'getUserInfo',
			'getAllDetectedImageResults',
			'updateUserInfo',
			'changePassword',
		]),

		countDown() {
			var now = Date.now();
			let endDate = this.trialEndDate;

			let daysDiff = moment(endDate).diff(now, 'days');
			let hoursDiff = moment(endDate).diff(now, 'hours') % 24;
			let minutesDiff = moment(endDate).diff(now, 'minutes') % 60;
			let secondsDiff = moment(endDate).diff(now, 'seconds') % 60;

			let days = daysDiff > 0 ? daysDiff : '0';
			let hours = hoursDiff > 0 ? hoursDiff : '0';
			let minutes = minutesDiff > 0 ? minutesDiff : '0';
			let seconds = secondsDiff > 0 ? secondsDiff : '0';

			this.countDownDateTime[0]['number'] = days >= 10 || days < 0 ? days : '0' + days;
			this.countDownDateTime[1]['number'] =
				hours >= 10 || hours < 0 ? hours : '0' + hours;
			this.countDownDateTime[2]['number'] =
				minutes >= 10 || minutes < 0 ? minutes : '0' + minutes;
			this.countDownDateTime[3]['number'] =
				seconds >= 10 || seconds < 0 ? seconds : '0' + seconds;
		},

		countDownTimer() {
			let countDownNumbers = this.countDownDateTime.filter((elm) => elm.number > 0);
			if (countDownNumbers.length == 0) {
				return;
			} else {
				setTimeout(() => {
					this.countDown();
					this.countDownTimer();
				}, 500);
			}
		},

		async onSave() {
			let newUserInfos = {
				email: this.userInfo.email,
				organization: this.userInfo.organization,
				region: this.userInfo.region,
			};
			let updateResponse = await this.updateUserInfo(newUserInfos);
			if (!updateResponse) {
				showToast({
					vueInstance: this,
					type: 'danger',
					message: this.$t('failedUpdateUserInfo'),
				});
				return;
			}

			showToast({
				vueInstance: this,
				type: 'success',
				message: this.$t('successUpdateUserInfo'),
			});
		},

		onChangePasswordBtnClick() {
			this.$bvModal.show('changePassword');
		},

		async confirmBtnClick() {
			this.$refs.observer.validate().then(async (success) => {
				if (success) {
					if (this.schema.oldPassword === this.schema.newPassword) {
						showSwal({
							type: 'fail',
							title: 'Warning',
							text: 'New password matches old password',
						});
						return;
					}
					try {
						let response = await this.changePassword({
							username: this.username,
							password: this.schema,
						});

						const swalPromise = showSwal({
							type: 'success',
							title: 'Success',
							text: 'Password changed',
						});

						this.schema = {
							oldPassword: '',
							newPassword: '',
							confirmNewPassword: '',
						};
						this.$bvModal.hide('changePassword');

						await swalPromise;

						localStorage.removeItem('token');
						this.$router.push('./login');
					} catch (error) {
						console.log(error);
						showSwal({
							type: 'fail',
							title: 'Failed',
							text: error.message,
						});
						return;
					}
				}
			});
		},

		cancelBtnClick() {
			this.$bvModal.hide('changePassword');
		},

		openRegionOptions() {
			this.regionsDropdownOpen = !this.regionsDropdownOpen;
		},

		onChooseRegion(region) {
			this.userInfo.region = region;
			this.regionsDropdownOpen = false;
		},

		toggleOldPassword() {
			this.isShowOldPassword = !this.isShowOldPassword;
		},

		toggleNewPassword() {
			this.isShowNewPassword = !this.isShowNewPassword;
		},

		toggleConfirmPassword() {
			this.isShowConfirmPassword = !this.isShowConfirmPassword;
		},
	},

	async mounted() {
		await this.getUserInfo(this.username);
		await this.getAllDetectedImageResults(this.username);
	},
};
